module.exports = __webpack_public_path__ + "img/Edit_Icon.b28e19be.svg";